export default "__VITE_ASSET__Bwy_DAiv__"